export default {
  namespaced: true,
  vxg_master_account: {
    title: "cuenta maestra",
    name: "Nombre",
    description: "Descripción",
    api_server: "Api server",
    api_user: "Usuario API",
    api_password: "Contraseña API",
    api_key: "Api clave",
    server_video: "Servidor de video",
    export_service_url: "URL del servicio de exportación",
    source_url: "Url resource",
    number_cameras: "Número de camaras",
    url: "Url api server",
  },
};
